<template>
  <div class="tryiton_wrapper">
    <slot name="disclaimer" />
    <button
      v-if="!isIE && isScriptLoaded"
      class="button-open-dsf-app btn btn--primary"
      :class="[isGhost ? 'btn--ghost' : 'btn--primary']"
    >
      {{ label }}
    </button>
    <button
      v-if="!isIE && !isScriptLoaded"
      class="btn"
      :class="[isGhost ? 'btn--ghost' : 'btn--primary']"
      @click="openVTO"
    >
      {{ label }}
    </button>
  </div>
</template>

<script>
  import { eventBus } from '@Foundation/eventbus/eventbus';
  export default {
    name: 'VtoButton',
    props: {
      label: { type: String, default: '', required: true },
      tagging: { type: Object, default: () => ({}) },
      isGhost: { type: Boolean, default: false },
    },
    data() {
      return {
        isScriptLoaded: false,
      };
    },
    computed: {
      isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE '); // IE 10 or older
        const trident = ua.indexOf('Trident/'); // IE 11

        return msie > 0 || trident > 0;
      },
    },

    mounted() {
      this.checkVTOImmediatelyOpen();
      this.clearSessionStorage();
    },
    methods: {
      checkVTOImmediatelyOpen() {
        setTimeout(() => {
          if (window.location.search.includes('vtoactive=1')) {
            this.openVTO();
          }
        }, 1000);
      },
      openVTO() {
        this.isScriptLoaded = true;
        window.eventBus.$emit('vto_enter');
        sessionStorage.setItem('vtoClicked', true);
      },
      clearSessionStorage() {
        window.addEventListener('beforeunload', function() {
          sessionStorage.removeItem('vtoClicked');
        });
      },
      openChannelAdvisor() {
        eventBus.$emit('open-channel-advisor-modal', this.channelAdvisorProps);
      },
    },
  };
</script>
